
<div class="workflow-wrapper panel-permissions fds" id="panel-permissions">
  <workarea key="workarea"></workarea>
</div>
